/* eslint-disable no-debugger */
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';
import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";

const getOrgLevelTypeHelpTextData = (orgLevelTypeId, state, setState) => {
    if (orgLevelTypeId) {
        const api = initApi(API_NAMES.COMMON, state, setState);
        const orgLevelTypeIdForUrl = orgLevelTypeId ? encodeURIComponent(orgLevelTypeId) : 'NaN';
        const url = `/OrgLevelTypeRequiredRole/OrgLevelType/${orgLevelTypeIdForUrl}/helptext`;

        return api?.executeObject ? api.executeObject(url, 'GET') : null;
    }
};

const OrgLevelTypeHelpTextData = { 
  INITIAL_STATE: BASIC_INITIAL_STATE, 
  getOrgLevelTypeHelpTextData };

export default OrgLevelTypeHelpTextData;